/**
 * "Which one is you" in a group (Miles, 2026-10-28: something between his profile and Jianing's
 * got mixed up). A group's "you" is the person the group's money goes to: you in your own groups,
 * the club treasurer in a group they run. It can never be someone with their own member account:
 * that person is them, so marking them as you puts their items, balance and tutoring pay on you.
 * The same rule for every group and every person, whatever their name.
 */
import type { GroupState } from "./types.ts";

/** Who holds a person in a group: an account's kind (absent: nobody has signed in as them). */
export type Holder = "owner" | "treasurer" | "member";

/**
 * Why `personId` can't be "Which one is you" in this group, or null when it can. `holderOf` says
 * whose account holds each person (the server knows; screens pass what they were sent).
 */
export function whyNotYou(
  state: GroupState,
  personId: string | null,
  holderOf: (personId: string) => Holder | undefined,
): string | null {
  if (!personId) return null;
  const p = state.people[personId];
  if (!p) return "That person isn't in this group";
  if (holderOf(personId) === "member")
    return `${p.name} has their own account, so they can't be you in this group. Pick the person who is you (or the club's treasurer).`;
  return null;
}
